<script>
import {h} from "vue";
// eslint-disable-next-line no-unused-vars
import UiTableCol from "@/components/ui/table/UiTableCol";
import UiTablePlaceholder from '@/components/ui/placeholders/UiTablePlaceholder'
import UiEmpty from '@/components/ui/empty-states/UiEmpty'
import {isArray} from 'lodash'

export default {
  name: "UiTable",
  components: {UiTablePlaceholder, UiEmpty},
  props: {
    rows: {
      //type: Array, Object,
      required: true
    }
  },
  methods: {
    renderColumns(row, columnsOptions, rowIdx) {
      // eslint-disable-next-line no-unused-vars
      return columnsOptions.map((column, index) => {
        let tdClass = 'px-1.5 py-2.5 text-sm text-gray-600'
        if (column.class) tdClass += ' ' + column.class
        let el;
        if (column.prop === 'index') {
          el = rowIdx + (column.from ? column.from : 1)
        } else {
          if (column.scopedSlot) {
            el = column.scopedSlot({row, items: this.rows, index: rowIdx})
          } else {
            // row prop
            //el = column.scopedSlot ? :

            let prop = column.prop.split('.')
            if (prop.length === 1) {
              el = row[prop[0]]
            } else if (prop.length === 2) {
              el = row[prop[0]][prop[1]]
            } else if (prop.length === 3) {
              el = row[prop[0]][prop[1]][prop[3]]
            }
            //custom format function
            if (column.format) {
              el = column.format(el)
            }
          }


        }


        return h('td', {class: tdClass}, [el])
      })
    }
  },
  render() {
    const columnsOptions = this.$slots.default().filter(item => {
      //console.log(item)
      return (item.type?.name === 'UiTableCol')
    }).map(column => {
      //console.log(column)
      return Object.assign({}, column.props, {
            scopedSlot: column?.children?.default
          }
      )
    })

    const columnsHead = columnsOptions.map((column, index) => {
      return h('th', {
        class: 'px-2 py-2.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider',
        key: index
      }, column.label)
    })
    if (!isArray(this.rows)) {
      return h(UiTablePlaceholder)
    }
    /*if (this.rows.length < 1) {
      return h(UiEmpty)
    }*/

    const rows = this.rows.map((row, index) => {
      return h('tr', {
        key: index,
        class: index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
      }, [this.renderColumns(row, columnsOptions, index)])
    })

    return h('div', {class: 'align-middle inline-block min-w-full'}, [
      h('div', {class: ''}, [
        h('table', {class: 'min-w-full divide-y divide-gray-200'}, [
          h('thead', {class: 'bg-gray-50'}, [
            h('tr', null, [columnsHead])
          ]),
          h('tbody', null, [rows]),
          h('tfoot', null, this.$slots.tfoot ? this.$slots.tfoot() : [])
        ])
      ])
    ])

  }

}
</script>